module.exports = __webpack_public_path__ + "img/777a.6c00d6c8.png";